/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import React from 'react';

const PriceTypeCustomCheckbox = ({
  column,
  rowIndex,
  node,
  validateBtnDisable,
  disabled = false,
  value,
}) => {
  const checkedHandler = (e) => {
    const checked = e.target.checked === true ? 1 : 0;
    const { colId } = column;
    node.setDataValue(colId, checked);
    if (validateBtnDisable) {
      validateBtnDisable();
    }
  };
  return (
    <div
      className="tbl-checkbox"
      id="checkbox"
      style={{ textAlign: 'left', float: 'left' }}
    >
      <FormControlLabel
        id={`${column.colId}--${rowIndex}`}
        control={<Checkbox color="primary" />}
        disabled={disabled || false}
        checked={value === 1 || value}
        onChange={checkedHandler}
        aria-label="checkbox"
      />
    </div>
  );
};

export default PriceTypeCustomCheckbox;
